// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3hXW8","approved":"Status_approved__2gEKQ","rejected":"Status_rejected__2Khf2","expired":"Status_expired__22_nJ","label":"Status_label__1lbHN"};